import { render, staticRenderFns } from "./CollaborativeList.vue?vue&type=template&id=be14f292&scoped=true"
import script from "./CollaborativeList.vue?vue&type=script&lang=js"
export * from "./CollaborativeList.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeList.vue?vue&type=style&index=0&id=be14f292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be14f292",
  null
  
)

export default component.exports